module.exports = __webpack_public_path__ + "img/party_lower_6.924028cf.jpg";